import React from 'react';
import { PropInfo, CodeExample, DatePickerProps } from '@cimpress/react-components';
import DatePickerCode from '!raw-loader!./datePicker.jsx';
import DatePickerDemo from './datePicker.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const DatePickerDocs = () => {
  const propInfos: PropInfo<DatePickerProps>[] = [
    {
      name: 'readonly',
      type: 'boolean',
      default: 'false',
      description: (
        <div>
          Indicates whether a selected date time is readonly and can only be set by selecting a date on the calendar.
        </div>
      ),
    },
    {
      name: 'label',
      type: 'string',
      default: '',
      description: (
        <div>
          Floating label for an input field. Use either this or <code>placeholder</code> but not both
        </div>
      ),
    },
    {
      name: 'helpText',
      type: 'node',
      default: '',
      description: 'Additional help text to display under the input field.',
    },
    {
      name: 'placeholder',
      type: 'string',
      default: '',
      description: 'The placeholder that will displayed inside the input box.',
    },
    {
      name: 'disabled',
      type: 'boolean',
      default: 'false',
      description: 'Indicates whether the input box should be disabled.',
    },
    {
      name: 'required',
      type: 'boolean',
      default: 'false',
      description: 'Indicates whether a selected date time is required.',
    },
    {
      name: 'isClearable',
      type: 'boolean',
      default: 'false',
      description: 'Indicates whether a selected date can be cleared.',
    },
    {
      name: 'onClickInput',
      type: 'function',
      default: '',
      description: 'Callback trigger for when the user clicks the input box.',
    },
  ];

  return (
    <div>
      <div>
        This component depends on react-datetime which has a peer dependency on moment. To import and use this component
        moment must be installed.
        <pre>npm install moment</pre>
      </div>
      <ComponentDoc<DatePickerProps> name="Date Picker" propInfos={propInfos}>
        <DatePickerDemo />
        <CodeExample code={DatePickerCode} />
      </ComponentDoc>
    </div>
  );
};

export default DatePickerDocs;
